export default "__VITE_ASSET__BvAN65Px__"